import Vue from 'vue'
import VueRouter from 'vue-router'

const axios = require('axios');

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: '',
        name: 'map',
        component: () => import('@/views/Map.vue'),
        meta: {
          title: "Mappa COVID-19 Valle Camonica"
        }
      }
    ]
  },
  {
    path: '/credits',
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: '',
        name: 'credits',
        component: () => import('@/views/Credits.vue'),
        meta: {
          title: "Riconoscimenti"
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  axios.post(`${process.env.VUE_APP_API_ENDPOINT}/record-view`, {
    route: to.name
  })

  next()
})

export default router